import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { CTA } from '../../interfaces/CTA.interface';
import { SectionTitleAlignment } from '../../interfaces/enums/SectionTitleAlignment';
import SectionTitle from './SectionTitle';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer';

interface SectionTitleProps extends Blok {
  subtitle?: string;
  title: string;
  body: StoryblokRichtext;
  cta?: CTA[];
  theme: Theme;
  alignment: SectionTitleAlignment;
}

interface SectionTitleBlokProps {
  blok: SectionTitleProps;
}

const SectionTitleBlok: React.FC<SectionTitleBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <SectionTitle {...blok} />
    </div>
  );
};

export default memo(withBlokWrapper(SectionTitleBlok));
